module.exports = __webpack_public_path__ + "img/dd8bc99.jpg";